export const trabajos = [
  {
    id: "Pharma",
    nombre: "Pharma.",
    url: "https://tati20h.github.io/pharma/#/home",
    tecnologias: "REACT.JS, MUIX, OpenFDA API",
    categorias: "Full-Stack",
    imagen:
      "https://github.com/Tati20h/pharma/blob/main/src/assets/img/logo.png?raw=true",
    Descripcion:
      "Web in React that uses the OpenFDA API that allows searching for US medications",
  },

  {
    id: "frontend-ehour",
    nombre: "Labor certificates.",
    url: "https://certifications-generator-jmbrv.ondigitalocean.app/",
    tecnologias: "REACT.JS, NODEJS - EXPRESS, FIGMA, MUIX",
    categorias: "Front-end",
    imagen:
      "https://github.com/Tati20h/08-portafolio/blob/main/src/assets/img/certipdf.png?raw=true",
    Descripcion: "Generator of labor certificates in PDF format.",
  },

  {
    id: "data-lovers",
    nombre: "Delie Taste.",
    url: "https://yennyferjp.github.io/DEV008-data-lovers/",
    tecnologias: "HTML, CSS, JAVASCRIPT, FIGMA, Web APIs",
    categorias: "Front-end",
    imagen:
      "https://github.com/Tati20h/DEV008-data-lovers/blob/main/src/img/imgbanner.png?raw=true",
    Descripcion: "E-commerce restaurant website",
  },
  {
    id: "social-network",
    nombre: "Warmi.",
    url: "https://tati20h.github.io/DEV008-social-network/",
    tecnologias:
      "HTML, CSS, JS, SPA, FIGMA, Design Responsive, Firestore, Firebase",
    imagen:
      "https://github.com/Tati20h/08-portafolio/blob/main/src/assets/img/warmi.png?raw=true",
    categorias: "Front-end",
    Descripcion: "Social Network for Latina Women Abroad",
  },
  {
    id: "Md-links",
    nombre: "Md-Links.",
    url: "https://www.npmjs.com/package/tatii-md-links",
    tecnologias: "JavaScript API, Node.js, Markdown, HTTP, Testing con JEST",
    categorias: "Back-end",
    imagen:
      "https://github.com/Tati20h/DEV008-md-links/blob/main/img/mdlinks.png?raw=true",
    Descripcion: "JavaScript CLI interface for validate files by path.",
  },
  {
    id: "burger-queen-api-client",
    nombre: "Burger Queen",
    url: "https://github.com/Tati20h/DEV009-burger-queen-api-client",
    tecnologias: "REACT.JS, FIGMA, Mock APIs, SWAGGER, NODEJS",
    categorias: "Front-end",
    imagen:
      "https://github.com/Tati20h/DEV009-burger-queen-api-client/blob/main/src/assets/img/burger.png?raw=true",
    Descripcion: "Ecommerce Burger Restaurant Website",
  },
  {
    id: "06-proyecto1",
    nombre: "Mis Pelis.",
    url: "https://github.com/Tati20h/06-proyecto1",
    tecnologias: "REACT.JS, FIGMA",
    categorias: "Front-end",
    imagen:
      "https://github.com/Tati20h/06-proyecto1/blob/main/src/img/Movies.png?raw=true",
    Descripcion: "Movie streaming platform",
  },
];
